<template>
  <card-container
    :id="pageId"
    :class="pageId"
    :is-loading="status.isLoading"
    no-action
    loading-message="Loading Statistics Data..."
  >
    <template #title>
      Service Metrics
    </template>

    <template #content>
      <template v-if="isNoDataReady">
        <message-html
          :has-top-line="false"
          :result-html="status.errorHtml"
        />
      </template>

      <template v-else>
        <div class="row justify-content-center">
          <el-radio-group v-model="dataType">
            <el-radio-button
              v-for="(item, index) in dataTypeList"
              :key="index"
              :label="item"
            />
          </el-radio-group>
        </div>

        <completed-transactions
          v-if="dataType === dataTypeList[0]"
          :data="completedTransactionsData"
        />

        <active-callers
          v-if="dataType === dataTypeList[1]"
          :data="activeCallersData"
        />
      </template>
    </template>
  </card-container>
</template>

<script setup lang="ts">
import { ref, Ref, reactive, computed, defineAsyncComponent } from 'vue';

import util from '@/Utils/util';
import { ServiceMetricsDataType } from '@/models/statistic';
import { statisticsService } from '@/services/statistics';

const CompletedTransactions = defineAsyncComponent(() => import('./Statistics/CompletedTransactions.vue') as any);

const ActiveCallers = defineAsyncComponent(() => import('./Statistics/ActiveCallers.vue') as any);

const pageId = 'service-metrics';
const dataTypeList = ['Completed Transactions', 'Active Customers'];

const dataType = ref('');
const status = reactive({
  isLoading: false,
  errorHtml: '',
});

const completedTransactionsData: Ref<ServiceMetricsDataType[]> = ref([]);
const activeCallersData: Ref<ServiceMetricsDataType[]> = ref([]);

const isNoDataReady = computed(() => {
  return completedTransactionsData.value.length === 0 && activeCallersData.value.length === 0;
});

const fetchServiceMetricsData = async () => {
  status.isLoading = true;
  try {
    const response = await statisticsService.fetchServiceMetricsData();

    completedTransactionsData.value = response
      .filter((item: ServiceMetricsDataType) => item.dataType === 'completedTransactions')
      .filter((item: ServiceMetricsDataType, index: number) => index !== 0); // it is need to remove current week data

    activeCallersData.value = response
      .filter((item: ServiceMetricsDataType) => item.dataType === 'activeCallers')
      .filter((item: ServiceMetricsDataType, index: number) => index !== 0); // it is need to remove current week data

    dataType.value = dataTypeList[0];
  } catch (error) {
    status.errorHtml = util.getGraphqlError(error);
  }
  status.isLoading = false;
};

fetchServiceMetricsData();
</script>

<style lang="scss">
.service-metrics {
  .card {
    min-height: 140px;
  }
}
</style>
